import React, { ReactNode } from "react";
import classnames from 'classnames';

let Styles: any;

try {
    Styles = require('./ModalPopUp_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{
    Styles = require('./ModalPopUp.module.scss');
}

interface PopUpProps{
    children: ReactNode,
    classNameStyle :string
}

const PopUp: React.FC<PopUpProps> = (props: PopUpProps) => {
    const {children, classNameStyle } = props ;
    return (
        <div className={Styles.popUp}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className={classNameStyle}>
                        <div className={classnames(Styles.shadow, Styles.rounded, "card text-center")}>
                            <div className="card-body">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopUp;